export default __webpack_public_path__ + "static/media/Protector OSD promo.fcb823fd.jpg";